export default __webpack_public_path__ + "static/media/icon-U.d938f4ba.svg";